<template>
  <section class="page-container">
    <h1>Quotes</h1>
    <!--    <div class="filter-container">-->
    <!--      <div class="flex">-->
    <!--        <div class="filter-box">-->
    <!--          <span class="label">Search</span>-->
    <!--          <div class="search-box">-->
    <!--            <v-input-->
    <!--              v-model="search"-->
    <!--              placeholder="Quotation No., Customer Name, Insurer, Referrer or Price"-->
    <!--              @keyEnter="filterData" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="filter-box">-->
    <!--          <span class="label">Quote Date</span>-->
    <!--          <div class="search-box">-->
    <!--            <v-date-picker-->
    <!--              v-model="date"-->
    <!--              type="daterange"-->
    <!--              @change="filterData" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="filter-box">-->
    <!--        <span class="label">-->
    <!--          Product Type-->
    <!--          <span-->
    <!--            class="all"-->
    <!--            @click="handlerSelectAll('product_id')">Select All</span>-->
    <!--        </span>-->
    <!--        <v-checkbox-group-->
    <!--          v-model="product_id"-->
    <!--          :list="productTypeOptions"-->
    <!--          @change="filterData"></v-checkbox-group>-->
    <!--      </div>-->
    <!--      <div class="filter-box">-->
    <!--        <span class="label">-->
    <!--          Insurer-->
    <!--          <span-->
    <!--            class="all"-->
    <!--            @click="handlerSelectAll('company_id')">Select All</span>-->
    <!--        </span>-->
    <!--        <v-checkbox-group-->
    <!--          v-model="company_id"-->
    <!--          :list="insurerOptions"-->
    <!--          @change="filterData"></v-checkbox-group>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; <div class="filter-box">-->
    <!--            <span class="label">-->
    <!--              Status-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerSelectAll('stts')">Select All</span>-->
    <!--            </span>-->
    <!--            <v-checkbox-group-->
    <!--              v-model="stts"-->
    <!--              :list="statusOptions"-->
    <!--              @change="filterData"></v-checkbox-group>-->
    <!--          </div> &ndash;&gt;-->
    <!--    </div>-->
    <quote-list></quote-list>
    <!--    <div class="filter-top">-->
    <!--      &lt;!&ndash;      <span>Search</span>&ndash;&gt;-->
    <!--      <v-input-->
    <!--        v-model="search"-->
    <!--        :prefixIcon="'el-icon-search'"-->
    <!--        placeholder="ID,Customer Name,Contact,Referrer Name,Price"-->
    <!--        @keyEnter="filterData" />-->
    <!--    </div>-->
    <!--    <div class="filter-card">-->

    <!--      <div class="filter-main">-->
    <!--        <div class="filter-left">-->
    <!--          <div class="form-item">-->
    <!--            <span>Created</span>-->
    <!--            <v-date-picker-->
    <!--              v-model="date"-->
    <!--              type="daterange"-->
    <!--              @change="filterData" />-->
    <!--          </div>-->
    <!--          <div class="form-item">-->
    <!--            <span>-->
    <!--              Insurer-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerSelectAll('company_id')">All</span>-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerNoneAll('company_id')">None</span>-->
    <!--            </span>-->
    <!--            <v-checkbox-group-->
    <!--              v-model="company_id"-->
    <!--              :list="insurerOptions"-->
    <!--              :block="true"-->
    <!--              @change="filterData"-->
    <!--            />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="filter-middler">-->
    <!--          <div class="form-item">-->
    <!--            <span>-->
    <!--              Product Type-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerSelectAll('product_id')"> All</span>-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerNoneAll('product_id')">None</span>-->
    <!--            </span>-->
    <!--            <div class="flex-sb">-->
    <!--              <div class="form-half">-->
    <!--                <span>Auto-Quote</span>-->
    <!--                <v-checkbox-group-->
    <!--                  v-model="product_id"-->
    <!--                  :list="productTypeOptions"-->
    <!--                  :block="true"-->
    <!--                  @change="filterData"></v-checkbox-group>-->
    <!--              </div>-->
    <!--              &lt;!&ndash;              <div class="form-half">&ndash;&gt;-->
    <!--              &lt;!&ndash;                <span>SME</span>&ndash;&gt;-->
    <!--              &lt;!&ndash;                <v-checkbox-group&ndash;&gt;-->
    <!--              &lt;!&ndash;                  v-model="product_id"&ndash;&gt;-->
    <!--              &lt;!&ndash;                  :list="ticketOptions.categoryOptions"&ndash;&gt;-->
    <!--              &lt;!&ndash;                  :block="true"&ndash;&gt;-->
    <!--              &lt;!&ndash;                  @change="filterData"></v-checkbox-group>&ndash;&gt;-->
    <!--              &lt;!&ndash;              </div>&ndash;&gt;-->
    <!--              &lt;!&ndash; <div class="form-half">-->
    <!--                <span>&nbsp;</span>-->
    <!--                <v-checkbox-group-->
    <!--                  v-model="product_id"-->
    <!--                  :list="ticketOptions.industryOptions"-->
    <!--                  :block="true"-->
    <!--                  @change="filterData"></v-checkbox-group>-->
    <!--              </div> &ndash;&gt;-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="filter-right">-->
    <!--          <div class="form-item">-->
    <!--            <span>-->
    <!--              Status-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerSelectAll('stts')">All</span>-->
    <!--              <span-->
    <!--                class="all"-->
    <!--                @click="handlerNoneAll('stts')">None</span>-->
    <!--            </span>-->
    <!--            <v-checkbox-group-->
    <!--              v-model="stts"-->
    <!--              :list="quoteStautsOption"-->
    <!--              :block="true"-->
    <!--              @change="filterData">-->
    <!--              <template #default="{ item }">-->
    <!--                <span class="flex">-->
    <!--                  <span-->
    <!--                    class="circle"-->
    <!--                    :class="{-->
    <!--                      'yellow-dark': item.id == 4,-->
    <!--                      'blue': [1, 5].includes(item.id),-->
    <!--                      'red': [6].includes(item.id),-->
    <!--                      'purple': [3].includes(item.id)-->
    <!--                    }"></span>-->
    <!--                  <span>{{ item['name'] }}</span>-->
    <!--                </span>-->
    <!--              </template>-->
    <!--            </v-checkbox-group>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="transparent">-->
    <!--      <el-table-->
    <!--        :data="tableData"-->
    <!--        style="width: 100%"-->
    <!--        :header-row-class-name="'tableHeader'"-->
    <!--        @row-click="rowClick">-->
    <!--        <el-table-column-->
    <!--          prop="quote_dt"-->
    <!--          label="Date & Time"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="id"-->
    <!--          label="ID"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="product_type"-->
    <!--          label="Product Type"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="insurer"-->
    <!--          label="Insurer"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="price"-->
    <!--          label="Price"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="contact_nm"-->
    <!--          label="Contact Name"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="phone_no"-->
    <!--          label="Phone No."></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="referrer_nm"-->
    <!--          label="Referrer"></el-table-column> -->
    <!--        <el-table-column-->
    <!--          prop="policy_period"-->
    <!--          label="Policy Period"></el-table-column>-->
    <!--        <el-table-column-->
    <!--          prop="stts_language"-->
    <!--          label="Status">-->
    <!--          <template #default="{ row }">-->
    <!--            <span-->
    <!--              class="span-status"-->
    <!--              :class="{-->
    <!--                'yellow-dark': row.stts == 4,-->
    <!--                'blue': [1, 5].includes(row.stts),-->
    <!--                'red': [6].includes(row.stts),-->
    <!--                'purple': [3].includes(row.stts)-->
    <!--              }">-->
    <!--              {{ row.stts_language }}-->
    <!--            </span>-->
    <!--          </template>-->
    <!--        </el-table-column>-->
    <!--      </el-table>-->
    <!--    </div>-->

    <!--    <v-pagination-->
    <!--      :total="pageConfig.total"-->
    <!--      :current="pageConfig.currentPage"-->
    <!--      @currentChange="currentChange" />-->
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getOrderList} from '@/api/order'
import {mapActions} from 'vuex'
import quoteList from '@/views/records/quote/quoteList'

export default {
  name: 'Quotes',
  components:{
    quoteList
  },
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      // // todo
      // statusOptions: [
      //   {
      //     name: 'Quick Quote',
      //     id: 1
      //   },
      //   {
      //     name: 'Paid',
      //     id: 2
      //   }
      // ],
      date: '',
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: []
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getOrderList()
      }
    }
  },
  methods: {
    ...mapActions('quote', ['setIsBack']),
    rowClick(row) {
      this.setIsBack(null)
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'productTypeOptions'
          break
        case 'stts':
          origin = 'quoteStautsOption'
          break
        case 'company_id':
          origin = 'insurerOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getOrderList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getOrderList()
    },
    network() {
      return {
        getOrderList: async () => {
          const { data } = await getOrderList({
            quote_dt_start: this.date[0],
            quote_dt_end: this.date[1],
            product_id: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .filter-top{
    margin-bottom: 30px;
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .span-name {
    display: block;
    color: #24292E;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .form-half {
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .span-status {
    display: inline-block;
    margin-right: 15px;
    padding: 5px 10px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 14px;
    color: white;
    font-weight: 500;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09,
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;
      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        border-right: 1px solid #E1E4E8;
      }
      .filter-right {
        padding-left: 10px;
      }
    }
    .circle {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      min-width: 14px;
      min-height: 14px;
      border-radius: 100%;
      &.orange-light {
        background: #E36209;
      }
      &.yellow-dark {
        background: #DBAB09;
      }
      &.blue {
        background: #0366D6;
      }
      &.green {
        background: #28A745;
      }

      &.red {
        background: #D73A49;
      }
    }
  }
  .purple {
    background: #6F42C1;
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
}
</style>
